export const messageStyles = {
  messageCloudTaleLeft: `
    border-bottom-right-radius: 14px;
    left: -20px;
    width: 39px;
    bottom: -8px;
    content: "";
    height: 45px;
    position: absolute;
    transform: rotateY(180deg);
    clip-path: polygon(29% 43%, 41% 50%, 59% 58%, 75% 62%, 59% 67%, 46% 68%, 29% 67%, 17% 63%, 5% 55%, 17% 34%);
  `,
  messageCloudTaleRight: `
    right: -15px;
    width: 20px;
    bottom: -11px;
    content: "";
    background-color: red;
    height: 46px;
    width: 30px;
    position: absolute;
    clip-path: polygon(29% 43%, 41% 50%, 59% 58%, 75% 62%, 59% 67%, 46% 68%, 29% 67%, 17% 63%, 5% 55%, 17% 34%);
  `,
}